// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"7X3qK":[function(require,module,exports) {
class NSSCartDrawer extends HTMLElement {
    constructor(){
        super();
        this.debug = false;
        this.initialized = false;
        this.lastActiveTrigger = null;
        this.focusTrapActive = false;
        this.focusableSelector = [
            `a[href]`,
            `area[href]`,
            `button:not([disabled])`,
            `input:not([disabled]):not([type="hidden"])`,
            `select:not([disabled])`,
            `textarea:not([disabled])`,
            `[tabindex]:not([tabindex="-1"])`,
            `[contenteditable="true"]`
        ].join(`,`);
        this.handleTrapKeydown = this.handleTrapKeydown.bind(this);
    }
    connectedCallback() {
        if (this.debug) console.log(`[NSS] Cart Drawer connected.`);
        // Prevent duplicate initialization
        if (this.initialized) {
            if (this.debug) console.log(`[NSS] Cart Drawer already initialized, skipping.`);
            return;
        }
        this.initialized = true;
        this.initCartDrawer();
        this.syncDialogLabel();
        this.setDialogOpenState(false);
        // Store handler reference for cleanup
        this.sectionSelectHandler = (e)=>{
            const targetChildEl = e.target.querySelector(`nss-cart-drawer`);
            const popUpStatus = document.documentElement.getAttribute(`nss-pop-up-open`);
            if (targetChildEl === this) {
                if (this.debug) console.log(`[NSS] Editing cart drawer!`);
                this.openCart();
                setTimeout(()=>{
                    window.scrollTo(0, 0);
                }, 500);
            } else {
                this.closeCart(false);
                if (popUpStatus === `false`) document.documentElement.setAttribute(`nss-overlay-open`, false);
            }
        };
        document.addEventListener(`shopify:section:select`, this.sectionSelectHandler);
        window.NSS_OPEN_CART_DRAWER = ()=>{
            this.openCart();
        };
        window.NSS_CLOSE_CART_DRAWER = ()=>{
            this.closeCart();
        };
    }
    disconnectedCallback() {
        // Clean up event listeners to prevent memory leaks
        if (this.sectionSelectHandler) document.removeEventListener(`shopify:section:select`, this.sectionSelectHandler);
        if (this.overlayClickHandler) {
            const overlayEl = document.querySelector(`nss-overlay`);
            if (overlayEl) overlayEl.removeEventListener(`click`, this.overlayClickHandler);
        }
        this.deactivateFocusTrap(false);
        // Clean up cart toggle button handlers
        if (this.cartToggleHandlers) this.cartToggleHandlers.forEach(({ element, handler })=>{
            element.removeEventListener(`click`, handler);
        });
        this.initialized = false;
        if (this.debug) console.log(`[NSS] Cart Drawer disconnected and cleaned up.`);
    }
    async openCart(triggerElement = null) {
        document.documentElement.setAttribute(`nss-cart-drawer-open`, true);
        document.documentElement.setAttribute(`nss-overlay-open`, true);
        this.setDialogOpenState(true);
        this.activateFocusTrap(triggerElement);
        const response = await fetch("/cart.js");
        const cart = await response.json();
        this.announceCartOpened(cart.item_count || 0);
        Shopify.analytics.publish("custom_cart_viewed", {
            data: cart
        });
        if (this.debug) console.log(`[NSS] Cart Drawer opened.`);
    }
    closeCart(restoreFocus = true) {
        document.documentElement.setAttribute(`nss-cart-drawer-open`, false);
        document.documentElement.setAttribute(`nss-overlay-open`, false);
        this.setDialogOpenState(false);
        this.deactivateFocusTrap(restoreFocus);
        if (this.debug) console.log(`[NSS] Cart Drawer closed.`);
    }
    setDialogOpenState(isOpen) {
        this.setAttribute(`aria-hidden`, isOpen ? `false` : `true`);
        // aria-hidden alone doesn't stop a closed drawer's contents from being
        // keyboard-focusable; `inert` removes them from focus/tab order/AT too.
        if (isOpen) this.removeAttribute(`inert`);
        else this.setAttribute(`inert`, ``);
    }
    syncDialogLabel() {
        const cartTemplateEl = this.querySelector(`nss-cart-template`);
        const titleId = cartTemplateEl?.getAttribute(`nss-cart-dialog-title-id`);
        if (titleId) {
            this.setAttribute(`aria-labelledby`, titleId);
            this.removeAttribute(`aria-label`);
        }
    }
    announceCartOpened(itemCount) {
        const statusEl = this.querySelector(`[nss-cart-status]`);
        if (!statusEl) return;
        const noun = itemCount === 1 ? `item` : `items`;
        const preface = window.NSS_CART_OPEN_ANNOUNCEMENT || ``;
        const message = `${preface} Cart opened. ${itemCount} ${noun} in your cart.`.trim();
        statusEl.textContent = message;
        window.NSS_CART_OPEN_ANNOUNCEMENT = ``;
    }
    async toggleCart(triggerElement = null) {
        const status = document.documentElement.getAttribute(`nss-cart-drawer-open`);
        if (status === "true") this.closeCart();
        else await this.openCart(triggerElement);
    }
    getFocusableElements() {
        return [
            ...this.querySelectorAll(this.focusableSelector)
        ].filter((el)=>{
            if (el.hasAttribute(`disabled`)) return false;
            if (el.getAttribute(`aria-hidden`) === `true`) return false;
            const style = window.getComputedStyle(el);
            if (style.display === `none` || style.visibility === `hidden`) return false;
            return true;
        });
    }
    focusInitialElement() {
        const closeButton = this.querySelector(`.nss-cart__header button[nss-open-cart-drawer]`);
        if (closeButton) {
            closeButton.focus({
                preventScroll: true
            });
            return;
        }
        const focusableEls = this.getFocusableElements();
        if (focusableEls.length > 0) {
            focusableEls[0].focus({
                preventScroll: true
            });
            return;
        }
        this.setAttribute(`tabindex`, `-1`);
        this.focus({
            preventScroll: true
        });
    }
    activateFocusTrap(triggerElement = null) {
        if (triggerElement && !this.contains(triggerElement)) this.lastActiveTrigger = triggerElement;
        else if (!this.lastActiveTrigger && document.activeElement && !this.contains(document.activeElement)) this.lastActiveTrigger = document.activeElement;
        if (!this.focusTrapActive) {
            document.addEventListener(`keydown`, this.handleTrapKeydown);
            this.focusTrapActive = true;
        }
        requestAnimationFrame(()=>{
            this.focusInitialElement();
        });
    }
    deactivateFocusTrap(restoreFocus = true) {
        if (this.focusTrapActive) {
            document.removeEventListener(`keydown`, this.handleTrapKeydown);
            this.focusTrapActive = false;
        }
        if (restoreFocus && this.lastActiveTrigger && this.lastActiveTrigger.isConnected) this.lastActiveTrigger.focus({
            preventScroll: true
        });
        this.lastActiveTrigger = null;
    }
    handleTrapKeydown(e) {
        const isOpen = document.documentElement.getAttribute(`nss-cart-drawer-open`) === `true`;
        if (!isOpen) return;
        if (e.key === `Escape`) {
            e.preventDefault();
            this.closeCart();
            return;
        }
        if (e.key !== `Tab`) return;
        const focusableEls = this.getFocusableElements();
        if (focusableEls.length === 0) {
            e.preventDefault();
            return;
        }
        const firstEl = focusableEls[0];
        const lastEl = focusableEls[focusableEls.length - 1];
        const activeEl = document.activeElement;
        if (e.shiftKey && (activeEl === firstEl || !this.contains(activeEl))) {
            e.preventDefault();
            lastEl.focus({
                preventScroll: true
            });
            return;
        }
        if (!e.shiftKey && (activeEl === lastEl || !this.contains(activeEl))) {
            e.preventDefault();
            firstEl.focus({
                preventScroll: true
            });
        }
    }
    initCartDrawer() {
        // Cart toggle events - store handlers for cleanup
        const cartToggleBtnEls = document.querySelectorAll(`[nss-open-cart-drawer]`);
        this.cartToggleHandlers = [];
        cartToggleBtnEls.forEach((cartToggleBtnEl)=>{
            const handler = (e)=>{
                e.preventDefault();
                this.toggleCart(e.currentTarget);
            };
            cartToggleBtnEl.addEventListener(`click`, handler);
            this.cartToggleHandlers.push({
                element: cartToggleBtnEl,
                handler
            });
        });
        if (window.location.href.indexOf("#cart") > -1 || window.location.href.indexOf("?viewcart=true") > -1) {
            if (typeof window.NSS_REFRESH_AND_OPEN_CART === `function`) window.NSS_REFRESH_AND_OPEN_CART();
            else this.toggleCart();
        }
        const overlayEl = document.querySelector(`nss-overlay`);
        // Store overlay handler for cleanup
        this.overlayClickHandler = (e)=>{
            const status = document.documentElement.getAttribute(`nss-cart-drawer-open`);
            if (status === "true") this.closeCart();
        };
        overlayEl.addEventListener(`click`, this.overlayClickHandler);
    }
}
customElements.define("nss-cart-drawer", NSSCartDrawer);

},{}]},["7X3qK"], "7X3qK", "parcelRequire83e8")

//# sourceMappingURL=nss-cart-drawer.js.map
